import {Navigate} from 'react-router-dom';
import routes from '../../../components/routes/routes';
import {Box} from './Box';
import {useAuthStore} from '../../../common/stores/useAuthStore';

type GuardProps = {
  children?: React.ReactNode;
};

export const AuthGuard = ({children}: GuardProps) => {
  const session = useAuthStore(state => state.session);
  if (!session) {
    return <Navigate to={routes.signIn} replace />;
  }

  return <Box>{children}</Box>;
};
